import type { TFunction } from 'i18next';

export interface ConfirmDialogSubtitleState {
  isLoading: boolean;
  isError: boolean;
  nothingToSecure: boolean;
}

/**
 * Single source of truth for the confirm-campaign dialog's header subtitle across its
 * loading/error/empty/resolved states — mirrors `getSaleDialogSubtitle`'s own role for
 * the record-sale dialog (action-breakdown / "Breakdown loading, failure, and empty
 * states").
 */
export function getConfirmDialogSubtitle(
  t: TFunction<'offers'>,
  state: ConfirmDialogSubtitleState,
): string {
  if (state.isLoading) return t('workspace.header.confirmDialog.loadingBreakdown');
  if (state.isError) return t('workspace.header.confirmDialog.breakdownError');
  if (state.nothingToSecure) return t('workspace.header.confirmDialog.nothingToSecure');
  return t('workspace.header.confirmDialog.description');
}
